import OnlineHero from "./OnlineHero/OnlineHero";
import ProgramDetails from "./ProgramDetails/ProgramDetails";
import RoboticsKits from "./RoboticsKits/RoboticsKits";
import RegularProgram from "./RegularProgram/RegularProgram";
import InteractivePlatforms from "./InteractivePlatforms/InteractivePlatforms";
import CTAForm from "../CTAForm/CTAForm";

const OnlinePrograms = () => {
  return (
    <>
      <OnlineHero />
      <RegularProgram />
      <InteractivePlatforms />
      <RoboticsKits />
      <ProgramDetails />
      <CTAForm />
    </>
  );
};

export default OnlinePrograms;
